import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { Action } from 'com/gongxigames/math/core/game/enums/Action';
import { GlobalEventsMapForBackwardCompatibility } from '@gongxigames/framework/slot/events';
import {
    MultiSetsMulticampaignPromotionModule,
    MultiSetsMulticampaignPromotionLogic,
    MultiSetsMulticampaignPromotionStates,
} from '@gongxigames/framework/promotions';

export class MultiSetsMulticampaignPromotionInitState extends ModuleState<
    null,
    MultiSetsMulticampaignPromotionModule,
    GlobalEventsMapForBackwardCompatibility
> {
    protected setupEvents(): void {
        this.setEventHandler('General.Game.STARTED', this.onGameStarted.bind(this));
    }

    private onGameStarted(): void {
        const promotion = this.module.getPromotion<MultiSetsMulticampaignPromotionLogic>();

        if (promotion.hasPromotion()) {
            this.module.gotoState(
                this.isRestore ? MultiSetsMulticampaignPromotionStates.RESTORE : MultiSetsMulticampaignPromotionStates.START
            );
        } else {
            this.module.gotoState(MultiSetsMulticampaignPromotionStates.BASIC);
        }
    }

    private get isRestore(): boolean {
        return this.module.logic.nextAction !== Action.SPIN;
    }

    public onEnterState(): void {}
    public onLeaveState(): void {}
}
